import { service } from '@/ajax/request'

export const dataStoreDetection = (params: any) => (
    service({
        url: '/user/userMemberDetection/storeDetection',
        method: 'POST',
        params,
    })
)

export const dataStoreDetectionCount = (params: any) => (
    service({
        url: '/user/userMemberDetection/storeCountDetection',
        method: 'POST',
        params,
    })
)

export const dataStoreRecuperate = (params: any) => (
    service({
        url: '/pms/pmsProductExpend/storeData',
        method: 'POST',
        params,
    })
)

export const dataStoreMerchant = (params: any) => (
    service({
        url: '/prescription/merchant/merchantDeviceDetails',
        method: 'POST',
        params,
    })
)

// 舌诊数据导出
export const exportTongueData = (params: any) => (
    service({
        url: '/statistics/store-summary/tongue/export',
        method: 'GET',
        params,
        responseType: 'blob',
    })
)

// 脉诊数据导出
export const exportPulseData = (params: any) => (
    service({
        url: '/statistics/store-summary/pulse/export',
        method: 'GET',
        params,
        responseType: 'blob',
    })
)